(function () {
  'use strict';

  var MIN_SAVE_MS = 380;
  var PHASE_MS = 280;

  // Small allowlist — keep in sync with website/8 Phone RSVP/src/lib/dial-allowlist.ts
  var DIAL_CODES = [
    { dial: '+1', name: 'United States / Canada', placeholder: '(555) 000-0000', min: 10, max: 10 },
    { dial: '+44', name: 'United Kingdom', placeholder: '7700 000000', min: 10, max: 10 },
    { dial: '+33', name: 'France', placeholder: '6 00 00 00 00', min: 9, max: 9 },
    { dial: '+49', name: 'Germany', placeholder: '151 00000000', min: 10, max: 11 },
    { dial: '+61', name: 'Australia', placeholder: '4 0000 0000', min: 9, max: 9 },
    { dial: '+353', name: 'Ireland', placeholder: '85 000 0000', min: 9, max: 9 },
    { dial: '+31', name: 'Netherlands', placeholder: '6 00000000', min: 9, max: 9 },
    { dial: '+34', name: 'Spain', placeholder: '600 000 000', min: 9, max: 9 },
    { dial: '+39', name: 'Italy', placeholder: '320 000 0000', min: 9, max: 10 },
    { dial: '+41', name: 'Switzerland', placeholder: '76 000 00 00', min: 9, max: 9 },
    { dial: '+64', name: 'New Zealand', placeholder: '21 000 0000', min: 8, max: 10 },
    { dial: '+52', name: 'Mexico', placeholder: '55 0000 0000', min: 10, max: 10 },
    { dial: '+55', name: 'Brazil', placeholder: '11 90000 0000', min: 10, max: 11 },
    { dial: '+81', name: 'Japan', placeholder: '90 0000 0000', min: 10, max: 10 },
    { dial: '+82', name: 'South Korea', placeholder: '10 0000 0000', min: 9, max: 10 },
  ];

  var DIAL_BY_CODE = {};
  DIAL_CODES.forEach(function (entry) {
    DIAL_BY_CODE[entry.dial] = entry;
  });

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, prefersReducedMotion() ? 0 : ms);
    });
  }

  function findDialEntry(dial) {
    return DIAL_BY_CODE[dial] || null;
  }

  function normalizeDialInput(raw) {
    var digits = String(raw || '').replace(/\D/g, '').slice(0, 4);
    return digits ? '+' + digits : '+';
  }

  function matchAllowlistedDial(raw) {
    var normalized = normalizeDialInput(raw);
    if (findDialEntry(normalized)) return normalized;

    // Longest matching allowlisted prefix (e.g. user typed +3531…)
    var digits = normalized.slice(1);
    var best = null;
    DIAL_CODES.forEach(function (entry) {
      var code = entry.dial.slice(1);
      if (digits === code || digits.indexOf(code) === 0) {
        if (!best || entry.dial.length > best.length) best = entry.dial;
      }
    });
    return best;
  }

  function formatUsPhone(value) {
    var digits = value.replace(/\D/g, '').slice(0, 10);
    var parts = [];
    if (digits.length > 0) parts.push('(' + digits.slice(0, 3));
    if (digits.length >= 3) parts[0] += ') ';
    if (digits.length > 3) parts.push(digits.slice(3, 6));
    if (digits.length > 6) parts.push('-' + digits.slice(6, 10));
    return parts.join('').trim();
  }

  function formatNationalPhone(value, dial) {
    var entry = findDialEntry(dial) || DIAL_CODES[0];
    if (entry.dial === '+1') return formatUsPhone(value);
    return value.replace(/\D/g, '').slice(0, entry.max);
  }

  function nationalDigitsForSubmit(value, dial) {
    var digits = String(value || '').replace(/\D/g, '');
    var entry = findDialEntry(dial);
    if (!entry) return digits;

    // Drop a single trunk leading 0 for non-NANP (e.g. UK 07700… → 7700…)
    if (entry.dial !== '+1' && digits.charAt(0) === '0') {
      digits = digits.slice(1);
    }

    // Guard against pasting country code into the national field
    var countryDigits = entry.dial.slice(1);
    if (digits.indexOf(countryDigits) === 0 && digits.length > entry.max) {
      digits = digits.slice(countryDigits.length);
    }

    return digits.slice(0, entry.max);
  }

  function isNationalComplete(digits, dial) {
    var entry = findDialEntry(dial);
    if (!entry) return false;
    return digits.length >= entry.min && digits.length <= entry.max;
  }

  function resizeDialInput(el, dial) {
    if (!el) return;
    var len = Math.max(2, String(dial || '+1').length);
    el.style.width = len + 'ch';
  }

  function splitSuccessCopy(raw) {
    var text = (raw || '').trim();
    var match = text.match(/^you'?re in\s*[—–-]\s*(.+)$/i);
    if (match) {
      return { title: "you're in", body: match[1] };
    }
    if (/^you'?re in\.?$/i.test(text)) {
      return { title: "you're in", body: '' };
    }
    return { title: "you're in", body: text };
  }

  function trackRsvp(eventName, params) {
    var payload = params || {};

    if (typeof gtag === 'function') {
      gtag('event', eventName, payload);
    } else if (typeof dataLayer !== 'undefined' && dataLayer.push) {
      dataLayer.push(Object.assign({ event: eventName }, payload));
    }

    if (typeof posthog !== 'undefined' && typeof posthog.capture === 'function') {
      posthog.capture(eventName, payload);
    }
  }

  function initSmsForm(form) {
    var input = form.querySelector('[data-nr-sms-input]');
    var field = form.querySelector('[data-nr-sms-field]');
    var dialWrap = form.querySelector('[data-nr-sms-dial]');
    var dialInput = form.querySelector('[data-nr-sms-dial-input]');
    var dialToggle = form.querySelector('[data-nr-sms-dial-toggle]');
    var dialList = form.querySelector('[data-nr-sms-dial-list]');
    var message = form.querySelector('[data-nr-sms-message]');
    var submitBtn = form.querySelector('[type="submit"]');
    var consentCheckbox = form.querySelector('[data-nr-sms-consent]');
    var consentBlock = form.querySelector('.nr-sms-signup__consent-block');
    var vipBlock = form.querySelector('[data-nr-sms-vip]');
    var vipToggle = form.querySelector('[data-nr-sms-vip-toggle]');
    var vipField = form.querySelector('[data-nr-sms-vip-field]');
    var vipRow = form.querySelector('.nr-sms-signup__vip-row');
    var vipInput = form.querySelector('[data-nr-sms-vip-input]');
    var vipSubmit = form.querySelector('[data-nr-sms-vip-submit]');
    var vipMessage = form.querySelector('[data-nr-sms-vip-message]');
    var endpoint = (form.getAttribute('data-nr-sms-endpoint') || '').replace(/\/+$/, '');
    var eventId = form.getAttribute('data-nr-sms-event') || '';
    var successMessage = form.getAttribute('data-nr-sms-success') || "you're in — see you at the next one";
    var namePrompt = form.getAttribute('data-nr-sms-name-prompt') || "you're in — what should we call you?";
    var namePlaceholder = form.getAttribute('data-nr-sms-name-placeholder') || 'your name';
    var defaultPhonePlaceholder = input ? input.getAttribute('placeholder') : '';
    var successParts = splitSuccessCopy(successMessage);
    var requireName = form.hasAttribute('data-nr-sms-require-name');
    var profileStep = form.getAttribute('data-nr-sms-profile-step') || '';
    var invitePanel = form.querySelector('[data-nr-sms-invite]');
    var profileToken = '';
    var typedName = '';
    var doneText = '';

    var submitting = false;
    var phase = 'phone';
    var cleanPhone = '';
    var skipLink = null;
    var progress = null;
    var formStarted = false;
    var formSucceeded = false;
    var selectedDial = '+1';
    var dialOpen = false;
    var vipEnabled = false;
    var vipExpanded = false;
    var vipChecking = false;
    var vipAccepted = false;
    var verifiedVipCode = '';

    function rsvpParams(extra) {
      var params = Object.assign({}, extra || {});
      if (eventId) params.event_id = eventId;
      return params;
    }

    function trackSuccess() {
      if (formSucceeded) return;
      formSucceeded = true;
      trackRsvp('rsvp_form_success', rsvpParams());
    }

    function ensureProgress() {
      if (progress) return progress;
      progress = document.createElement('div');
      progress.className = 'nr-sms-signup__progress';
      progress.hidden = true;
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span class="nr-sms-signup__progress-bar"></span>';
      if (field && field.parentNode) {
        field.parentNode.insertBefore(progress, field.nextSibling);
      } else {
        form.insertBefore(progress, form.firstChild);
      }
      return progress;
    }

    function setProgress(active) {
      var el = ensureProgress();
      form.classList.toggle('nr-sms-signup--saving', active);
      el.hidden = !active;
      el.setAttribute('aria-hidden', active ? 'false' : 'true');
    }

    function setConsentVisible(visible) {
      if (!consentBlock) return;
      consentBlock.classList.toggle('nr-sms-signup__consent-block--hidden', !visible);
      consentBlock.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (consentCheckbox) consentCheckbox.disabled = !visible;
    }

    function updateVipVisibility() {
      if (!vipBlock) return;
      vipBlock.hidden = !(vipEnabled && phase === 'phone');
    }

    function setVipExpanded(expanded) {
      if (!vipField || !vipToggle) return;
      vipExpanded = expanded;
      vipField.hidden = !expanded;
      vipToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (expanded && vipInput) vipInput.focus();
    }

    function setVipLocked(locked) {
      if (vipInput && !vipAccepted) vipInput.disabled = locked;
      if (vipToggle) vipToggle.disabled = locked;
      if (vipSubmit && !vipAccepted) vipSubmit.disabled = locked;
    }

    function showVipMessage(text, kind) {
      if (!vipMessage) return;
      vipMessage.hidden = false;
      vipMessage.textContent = text;
      vipMessage.classList.remove('nr-sms-signup__vip-message--accepted', 'nr-sms-signup__vip-message--denied');
      if (kind) vipMessage.classList.add('nr-sms-signup__vip-message--' + kind);
    }

    function handleVipSubmit() {
      if (vipChecking || vipAccepted || !vipInput) return;
      var code = vipInput.value.trim();
      if (!code) {
        showVipMessage('enter a code', 'denied');
        return;
      }
      if (!endpoint || !eventId) return;

      vipChecking = true;
      vipInput.disabled = true;
      if (vipSubmit) vipSubmit.disabled = true;
      showVipMessage('checking…', null);

      fetch(endpoint + '/api/events/' + encodeURIComponent(eventId) + '/verify-vip-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data && data.valid) {
            vipAccepted = true;
            verifiedVipCode = code;
            vipInput.disabled = true;
            if (vipSubmit) {
              vipSubmit.disabled = true;
              vipSubmit.textContent = 'applied';
            }
            if (vipRow) vipRow.classList.add('nr-sms-signup__vip-row--accepted');
            showVipMessage('code accepted — enter your phone number above', 'accepted');
          } else {
            vipInput.disabled = false;
            if (vipSubmit) vipSubmit.disabled = false;
            showVipMessage('invalid code', 'denied');
          }
        })
        .catch(function () {
          vipInput.disabled = false;
          if (vipSubmit) vipSubmit.disabled = false;
          showVipMessage('network error — try again', 'denied');
        })
        .finally(function () {
          vipChecking = false;
        });
    }

    // Fetch whether this event has VIP enabled — the code itself is never
    // sent to the client, only the boolean gate. Never shown on the footer
    // form since that markup isn't rendered there at all (see liquid).
    if (vipBlock && endpoint && eventId) {
      fetch(endpoint + '/api/events/' + encodeURIComponent(eventId))
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (data) {
          if (data && data.vip_enabled) {
            vipEnabled = true;
            updateVipVisibility();
          }
        })
        .catch(function () {
          /* non-fatal — VIP prompt simply stays hidden */
        });
    }

    if (vipToggle) {
      vipToggle.addEventListener('click', function () {
        setVipExpanded(!vipExpanded);
      });
    }

    if (vipSubmit) {
      vipSubmit.addEventListener('click', function (e) {
        e.preventDefault();
        handleVipSubmit();
      });
    }

    if (vipInput) {
      vipInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleVipSubmit();
        }
      });
      vipInput.addEventListener('input', function () {
        if (vipAccepted) return;
        if (vipMessage && !vipMessage.hidden) {
          vipMessage.hidden = true;
          vipMessage.textContent = '';
        }
      });
    }

    function setDialEnabled(enabled) {
      if (dialInput) dialInput.disabled = !enabled;
      if (dialToggle) dialToggle.disabled = !enabled;
      if (!enabled) closeDialList();
    }

    function setFieldLocked(locked) {
      if (input) input.disabled = locked;
      if (submitBtn) submitBtn.disabled = locked;
      setDialEnabled(!locked && phase === 'phone');
      setVipLocked(locked);
      if (field) field.classList.toggle('nr-sms-signup__field--locked', locked);
    }

    function showMessage(text, kind) {
      if (!message) return;
      message.hidden = false;
      message.classList.remove(
        'nr-sms-signup__message--prompt',
        'nr-sms-signup__message--error',
        'nr-sms-signup__message--done',
        'nr-sms-signup__message--progress'
      );
      if (kind) message.classList.add('nr-sms-signup__message--' + kind);

      if (kind === 'done') {
        var titleText = successParts.title;
        var bodyText = text || '';
        if (text === "you're already on the list") {
          titleText = text;
          bodyText = '';
        }
        var title = document.createElement('span');
        title.className = 'nr-sms-signup__thanks-title';
        title.textContent = titleText;
        message.textContent = '';
        message.appendChild(title);
        if (bodyText) {
          var body = document.createElement('span');
          body.className = 'nr-sms-signup__thanks-body';
          body.textContent = bodyText;
          message.appendChild(body);
        }
      } else {
        message.textContent = text;
      }
    }

    function clearMessage() {
      if (!message) return;
      message.hidden = true;
      message.textContent = '';
      message.classList.remove(
        'nr-sms-signup__message--prompt',
        'nr-sms-signup__message--error',
        'nr-sms-signup__message--done',
        'nr-sms-signup__message--progress'
      );
    }

    function ensureSkipLink() {
      if (skipLink) return skipLink;
      skipLink = document.createElement('button');
      skipLink.type = 'button';
      skipLink.className = 'nr-sms-signup__skip nr-footer-panel__sms-skip';
      skipLink.textContent = 'skip';
      skipLink.hidden = true;
      skipLink.addEventListener('click', function () {
        finishName('');
      });
      if (message && message.parentNode) {
        message.parentNode.insertBefore(skipLink, message.nextSibling);
      } else {
        form.appendChild(skipLink);
      }
      return skipLink;
    }

    function setNamePhase(active) {
      if (field) {
        field.classList.toggle('nr-sms-signup__field--name', active);
        field.classList.toggle('nr-footer-panel__sms-field--name', active);
      }
      setDialEnabled(!active && phase === 'phone');
    }

    function enterDone(bodyText) {
      trackSuccess();
      phase = 'done';
      setProgress(false);
      setConsentVisible(false);
      updateVipVisibility();
      if (skipLink) skipLink.hidden = true;
      setFieldLocked(true);
      form.classList.add('nr-sms-signup--done');
      showMessage(bodyText || successParts.body || successMessage, 'done');
    }

    function enterNamePhase() {
      trackSuccess();
      phase = 'name';
      setProgress(false);
      setConsentVisible(false);
      updateVipVisibility();
      form.classList.remove('nr-sms-signup--done');
      setFieldLocked(false);

      if (input) {
        input.disabled = false;
        input.type = 'text';
        input.setAttribute('inputmode', 'text');
        input.setAttribute('autocomplete', 'off');
        input.placeholder = namePlaceholder;
        input.value = '';
      }
      if (submitBtn) submitBtn.disabled = false;
      setNamePhase(true);
      showMessage(namePrompt, 'prompt');
      ensureSkipLink().hidden = requireName;

      wait(PHASE_MS).then(function () {
        if (phase === 'name' && input) input.focus();
      });
    }

    function finishName(name) {
      if (submitting || phase !== 'name') return;
      var trimmed = (name || '').trim().slice(0, 100);
      if (requireName && !trimmed) {
        showMessage('please enter your name', 'error');
        if (input) input.focus();
        return;
      }
      typedName = trimmed;
      submitting = true;
      setFieldLocked(true);
      if (skipLink) skipLink.hidden = true;
      showMessage('almost there…', 'progress');
      setProgress(true);

      var started = Date.now();
      var patchPromise = Promise.resolve({ ok: true });

      if (trimmed && endpoint && eventId && cleanPhone) {
        patchPromise = fetch(endpoint + '/api/rsvp/name', {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: cleanPhone, eventId: eventId, name: trimmed }),
        })
          .then(function (res) {
            return { ok: res.ok };
          })
          .catch(function () {
            return { ok: false };
          });
      }

      Promise.all([patchPromise, wait(Math.max(0, MIN_SAVE_MS - (Date.now() - started)))])
        .then(function () {
          if (profileActive()) {
            enterProfile();
          } else {
            enterDone(successParts.body);
          }
        })
        .finally(function () {
          submitting = false;
          setProgress(false);
        });
    }

    // ── Post-RSVP profile step (physical invite / email) ────────────────────
    // Only on forms rendered with data-nr-sms-profile-step, and only when the
    // RSVP app returned a profile pass (older deploys don't, so the form falls
    // back to finishing as before).
    function profileActive() {
      return !!(invitePanel && profileStep && profileToken);
    }

    function showInviteView(name) {
      if (!invitePanel) return;
      invitePanel.hidden = !name;
      invitePanel.querySelectorAll('[data-nr-sms-invite-view]').forEach(function (view) {
        view.hidden = view.getAttribute('data-nr-sms-invite-view') !== name;
      });
    }

    function enterProfile() {
      phase = profileStep === 'invite' ? 'invite' : 'email';
      setProgress(false);
      setConsentVisible(false);
      updateVipVisibility();
      if (skipLink) skipLink.hidden = true;
      setFieldLocked(true);
      form.classList.add('nr-sms-signup--profile');
      clearMessage();
      showInviteView(phase === 'invite' ? 'choice' : 'email');
      wait(PHASE_MS).then(function () {
        var focusEl = phase === 'email'
          ? invitePanel.querySelector('[data-nr-sms-invite-email]')
          : invitePanel.querySelector('[data-nr-sms-invite-yes]');
        if (focusEl) focusEl.focus();
      });
    }

    function enterMailForm() {
      phase = 'mail';
      clearMessage();
      showInviteView('mail');
      var first = invitePanel.querySelector('[data-nr-mail="firstName"]');
      var last = invitePanel.querySelector('[data-nr-mail="lastName"]');
      if (typedName && first && !first.value) {
        var parts = typedName.split(/\s+/);
        first.value = parts.shift() || '';
        if (last && !last.value) last.value = parts.join(' ');
      }
      if (first) first.focus();
    }

    function enterDeclinedEmail() {
      phase = 'declined';
      clearMessage();
      showInviteView('email');
      var emailInput = invitePanel.querySelector('[data-nr-sms-invite-email]');
      if (emailInput) emailInput.focus();
    }

    function looksLikeEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function setInviteBusy(busy) {
      submitting = busy;
      setProgress(busy);
      invitePanel.querySelectorAll('input, button').forEach(function (el) {
        el.disabled = busy;
      });
    }

    function postProfile(payload) {
      setInviteBusy(true);
      showMessage('saving…', 'progress');
      var started = Date.now();
      var body = Object.assign({ phone: cleanPhone, eventId: eventId, profileToken: profileToken }, payload);

      return fetch(endpoint + '/api/rsvp/profile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          }, function () {
            return { ok: res.ok, data: null };
          });
        })
        .then(function (result) {
          return wait(Math.max(0, MIN_SAVE_MS - (Date.now() - started))).then(function () {
            return result;
          });
        })
        .then(function (result) {
          setInviteBusy(false);
          if (result.ok) {
            trackRsvp('rsvp_profile_saved', rsvpParams({ profile_path: phase }));
            showInviteView('');
            form.classList.remove('nr-sms-signup--profile');
            enterDone(doneText);
          } else {
            showMessage((result.data && result.data.error) || 'something went wrong — please try again', 'error');
          }
        })
        .catch(function () {
          setInviteBusy(false);
          showMessage('network error — please try again', 'error');
        });
    }

    function submitMailForm() {
      if (submitting || phase !== 'mail') return;
      var payload = {};
      invitePanel.querySelectorAll('[data-nr-mail]').forEach(function (el) {
        payload[el.getAttribute('data-nr-mail')] = el.value.trim();
      });
      if (!payload.firstName || !payload.lastName || !payload.email || !payload.line1 || !payload.city || !payload.postal) {
        showMessage('please fill in your name, email, and address', 'error');
        return;
      }
      if (!looksLikeEmail(payload.email)) {
        showMessage('please enter a valid email', 'error');
        return;
      }
      postProfile(payload);
    }

    function submitEmailStep(skip) {
      if (submitting || (phase !== 'email' && phase !== 'declined')) return;
      var emailInput = invitePanel.querySelector('[data-nr-sms-invite-email]');
      var email = skip || !emailInput ? '' : emailInput.value.trim();
      if (email && !looksLikeEmail(email)) {
        showMessage('please enter a valid email', 'error');
        return;
      }
      if (phase === 'declined') {
        postProfile({ mailDeclined: true, email: email });
      } else if (email) {
        postProfile({ email: email });
      } else {
        showInviteView('');
        form.classList.remove('nr-sms-signup--profile');
        enterDone(doneText);
      }
    }

    if (invitePanel) {
      var yesBtn = invitePanel.querySelector('[data-nr-sms-invite-yes]');
      var noBtn = invitePanel.querySelector('[data-nr-sms-invite-no]');
      var sendBtn = invitePanel.querySelector('[data-nr-sms-invite-send]');
      var backBtn = invitePanel.querySelector('[data-nr-sms-invite-back]');
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (submitting || phase !== 'mail') return;
          phase = 'invite';
          clearMessage();
          showInviteView('choice');
          if (noBtn) noBtn.focus();
        });
      }
      var emailSaveBtn = invitePanel.querySelector('[data-nr-sms-invite-email-save]');
      var emailSkipBtn = invitePanel.querySelector('[data-nr-sms-invite-email-skip]');
      if (yesBtn) yesBtn.addEventListener('click', function () { if (phase === 'invite') enterMailForm(); });
      if (noBtn) noBtn.addEventListener('click', function () { if (phase === 'invite') enterDeclinedEmail(); });
      if (sendBtn) sendBtn.addEventListener('click', submitMailForm);
      if (emailSaveBtn) emailSaveBtn.addEventListener('click', function () { submitEmailStep(false); });
      if (emailSkipBtn) emailSkipBtn.addEventListener('click', function () { submitEmailStep(true); });
    }

    function applyDial(dial, options) {
      var opts = options || {};
      var entry = findDialEntry(dial) || DIAL_CODES[0];
      selectedDial = entry.dial;
      if (dialInput) {
        dialInput.value = selectedDial;
        resizeDialInput(dialInput, selectedDial);
      }
      if (input && phase === 'phone') {
        if (opts.clear !== false) input.value = '';
        input.placeholder = entry.placeholder || defaultPhonePlaceholder || '';
        input.setAttribute('autocomplete', 'tel-national');
        input.setAttribute('inputmode', 'tel');
      }
      syncDialListSelection();
    }

    function syncDialListSelection() {
      if (!dialList) return;
      dialList.querySelectorAll('[data-nr-sms-dial-option]').forEach(function (btn) {
        var isSelected = btn.getAttribute('data-dial') === selectedDial;
        btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    function buildDialList() {
      if (!dialList) return;
      dialList.textContent = '';
      DIAL_CODES.forEach(function (entry) {
        var li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nr-sms-signup__dial-option';
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-nr-sms-dial-option', '');
        btn.setAttribute('data-dial', entry.dial);
        btn.setAttribute('aria-selected', entry.dial === selectedDial ? 'true' : 'false');

        var nameSpan = document.createElement('span');
        nameSpan.className = 'nr-sms-signup__dial-option-name';
        nameSpan.textContent = entry.name;

        var codeSpan = document.createElement('span');
        codeSpan.className = 'nr-sms-signup__dial-option-code';
        codeSpan.textContent = entry.dial;

        btn.appendChild(nameSpan);
        btn.appendChild(codeSpan);
        btn.addEventListener('click', function () {
          applyDial(entry.dial);
          closeDialList();
          if (input && phase === 'phone') input.focus();
        });
        li.appendChild(btn);
        dialList.appendChild(li);
      });
    }

    function openDialList() {
      if (!dialList || !dialWrap || phase !== 'phone') return;
      dialOpen = true;
      dialList.hidden = false;
      dialWrap.classList.add('nr-sms-signup__dial--open');
      if (dialToggle) dialToggle.setAttribute('aria-expanded', 'true');
      if (dialInput) dialInput.setAttribute('aria-expanded', 'true');
    }

    function closeDialList() {
      if (!dialList || !dialWrap) return;
      dialOpen = false;
      dialList.hidden = true;
      dialWrap.classList.remove('nr-sms-signup__dial--open');
      if (dialToggle) dialToggle.setAttribute('aria-expanded', 'false');
      if (dialInput) dialInput.setAttribute('aria-expanded', 'false');
    }

    function toggleDialList() {
      if (dialOpen) closeDialList();
      else openDialList();
    }

    function commitDialFromInput() {
      var matched = matchAllowlistedDial(dialInput ? dialInput.value : selectedDial);
      if (matched) {
        applyDial(matched, { clear: matched !== selectedDial });
        return true;
      }
      applyDial(selectedDial, { clear: false });
      return false;
    }

    if (dialList) buildDialList();
    applyDial('+1', { clear: false });

    if (dialToggle) {
      dialToggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (phase !== 'phone' || dialToggle.disabled) return;
        toggleDialList();
      });
    }

    if (dialInput) {
      dialInput.addEventListener('focus', function () {
        if (phase !== 'phone' || formStarted) return;
        formStarted = true;
        trackRsvp('rsvp_form_started', rsvpParams());
      });

      dialInput.addEventListener('input', function () {
        if (phase !== 'phone') return;
        var next = normalizeDialInput(dialInput.value);
        dialInput.value = next;
        resizeDialInput(dialInput, next);

        var matched = matchAllowlistedDial(next);
        if (matched && matched === next && matched !== selectedDial) {
          applyDial(matched);
        }
      });

      dialInput.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          openDialList();
        } else if (e.key === 'Escape') {
          closeDialList();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          commitDialFromInput();
          closeDialList();
          if (input) input.focus();
        }
      });

      dialInput.addEventListener('blur', function () {
        // Delay so option click can fire first
        setTimeout(function () {
          if (phase !== 'phone') return;
          commitDialFromInput();
        }, 120);
      });
    }

    document.addEventListener('mousedown', function (e) {
      if (!dialOpen || !dialWrap) return;
      if (!dialWrap.contains(e.target)) closeDialList();
    });

    if (input) {
      input.addEventListener('focus', function () {
        if (phase !== 'phone' || formStarted) return;
        formStarted = true;
        trackRsvp('rsvp_form_started', rsvpParams());
      });

      input.addEventListener('input', function () {
        if (phase !== 'phone') return;
        var caretAtEnd = input.selectionStart === input.value.length;
        var formatted = formatNationalPhone(input.value, selectedDial);
        input.value = formatted;
        if (caretAtEnd) {
          input.setSelectionRange(formatted.length, formatted.length);
        }
      });
    }

    function submitPhone() {
      commitDialFromInput();
      closeDialList();

      if (!findDialEntry(selectedDial)) {
        trackRsvp('rsvp_form_error', rsvpParams({ error_reason: 'invalid_dial' }));
        showMessage('please choose a supported country code', 'error');
        if (dialInput) dialInput.focus();
        return;
      }

      var digits = nationalDigitsForSubmit(input ? input.value : '', selectedDial);
      if (!isNationalComplete(digits, selectedDial)) {
        trackRsvp('rsvp_form_error', rsvpParams({ error_reason: 'invalid_phone' }));
        var entry = findDialEntry(selectedDial);
        var hint =
          selectedDial === '+1'
            ? 'please enter a valid 10-digit number'
            : 'please enter a valid phone number';
        if (entry && entry.min === entry.max) {
          hint =
            selectedDial === '+1'
              ? 'please enter a valid 10-digit number'
              : 'please enter a valid ' + entry.min + '-digit number';
        }
        showMessage(hint, 'error');
        return;
      }

      if (selectedDial === '+1' && /^[01]/.test(digits)) {
        trackRsvp('rsvp_form_error', rsvpParams({ error_reason: 'invalid_phone' }));
        showMessage('please enter your 10-digit number without a leading 1', 'error');
        return;
      }

      if (consentCheckbox && !consentCheckbox.checked) {
        trackRsvp('rsvp_form_error', rsvpParams({ error_reason: 'consent_required' }));
        showMessage('please agree to receive sms updates', 'error');
        if (consentCheckbox) consentCheckbox.focus();
        return;
      }
      if (!endpoint || !eventId) {
        trackRsvp('rsvp_form_error', rsvpParams({ error_reason: 'not_configured' }));
        showMessage('sms signup is not configured yet', 'error');
        return;
      }

      submitting = true;
      setFieldLocked(true);
      showMessage('signing you up…', 'progress');
      setProgress(true);

      var fullPhone = selectedDial + digits;
      var started = Date.now();

      fetch(endpoint + '/api/rsvp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: '',
          phone: fullPhone,
          eventId: eventId,
          consented: consentCheckbox ? consentCheckbox.checked : false,
          vipCode: vipAccepted ? verifiedVipCode : '',
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, status: res.status, statusText: res.statusText, data: data };
          }, function () {
            return { ok: res.ok, status: res.status, statusText: res.statusText, data: null };
          });
        })
        .then(function (result) {
          var elapsed = Date.now() - started;
          return wait(Math.max(0, MIN_SAVE_MS - elapsed)).then(function () {
            return result;
          });
        })
        .then(function (result) {
          var data = result.data || {};
          if (result.ok && profileStep && invitePanel && data.profileToken) {
            cleanPhone = fullPhone;
            profileToken = data.profileToken;
            doneText = data.status === 'already_registered' ? "you're already on the list" : successParts.body;
            if (data.hasName) {
              trackSuccess();
              enterProfile();
            } else {
              enterNamePhase();
            }
          } else if (data.status === 'already_registered') {
            cleanPhone = fullPhone;
            enterDone("you're already on the list");
          } else if (result.ok && data.returning === true) {
            cleanPhone = fullPhone;
            enterDone(successParts.body);
          } else if (result.ok) {
            cleanPhone = fullPhone;
            enterNamePhase();
          } else {
            setFieldLocked(false);
            setProgress(false);
            trackRsvp('rsvp_form_error', rsvpParams({
              error_reason: 'api_error',
              status_code: result.status,
              error_message: (result.data && result.data.error) || '',
              api_response: result.statusText || '',
            }));
            showMessage(data.error || 'something went wrong — please try again', 'error');
          }
        })
        .catch(function (err) {
          setFieldLocked(false);
          setProgress(false);
          trackRsvp('rsvp_form_error', rsvpParams({
            error_reason: 'network_error',
            error_message: (err && err.message) || 'network_error',
          }));
          showMessage('network error — please try again', 'error');
        })
        .finally(function () {
          submitting = false;
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting || phase === 'done') return;
      if (phase === 'name') {
        finishName(input ? input.value : '');
        return;
      }
      if (phase === 'mail') {
        submitMailForm();
        return;
      }
      if (phase === 'email' || phase === 'declined') {
        submitEmailStep(false);
        return;
      }
      if (phase === 'invite') return;
      trackRsvp('rsvp_form_submitted', rsvpParams());
      submitPhone();
    });

    // Policy links: single click toggles consent; dblclick / long-press opens.
    form.querySelectorAll('.nr-sms-signup__consent-text a').forEach(function (link) {
      var longPressTimer = null;
      var ignoreNextClick = false;
      var LONG_PRESS_MS = 500;

      link.setAttribute('title', 'Double-click or long-press to open');

      function openPolicy(e) {
        if (e) e.preventDefault();
        var href = link.getAttribute('href');
        if (href) window.open(href, '_blank', 'noopener');
      }

      function toggleConsent() {
        if (!consentCheckbox || consentCheckbox.disabled) return;
        consentCheckbox.checked = !consentCheckbox.checked;
        consentCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
      }

      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (ignoreNextClick) {
          ignoreNextClick = false;
          return;
        }
        toggleConsent();
      });

      link.addEventListener('dblclick', function (e) {
        e.preventDefault();
        openPolicy();
      });

      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPolicy();
        }
      });

      link.addEventListener('touchstart', function () {
        longPressTimer = setTimeout(function () {
          longPressTimer = null;
          ignoreNextClick = true;
          openPolicy();
        }, LONG_PRESS_MS);
      }, { passive: true });

      function clearLongPress() {
        if (longPressTimer) {
          clearTimeout(longPressTimer);
          longPressTimer = null;
        }
      }

      link.addEventListener('touchend', clearLongPress);
      link.addEventListener('touchmove', clearLongPress);
      link.addEventListener('touchcancel', clearLongPress);
    });
  }

  function init() {
    document.querySelectorAll('[data-nr-sms-form]').forEach(initSmsForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
